// import jwt_decode from "jwt-decode";
import CryptoJS from "crypto-js";

const SECRET_KEY =
  process.env.NEXT_PUBLIC_ENCRYPTION_KEY || "your-fallback-secret-key";

export const encryptData = (data: string): string => {
  try {
    if (!data) return "";
    return CryptoJS.AES.encrypt(data, SECRET_KEY).toString();
  } catch (error) {
    console.error("Encryption error:", error);
    return "";
  }
};

export const decryptData = (encryptedData: string | null): string | null => {
  try {
    if (!encryptedData) return null;

    // Check if the data is actually encrypted
    if (!encryptedData.startsWith("U2F") && !encryptedData.includes("+")) {
      // If it's not encrypted, return as is (for backward compatibility)
      return encryptedData;
    }

    const bytes = CryptoJS.AES.decrypt(encryptedData, SECRET_KEY);
    const decrypted = bytes.toString(CryptoJS.enc.Utf8);

    // Validate the decrypted data
    if (!decrypted) {
      throw new Error("Decryption resulted in empty string");
    }

    return decrypted;
  } catch (error) {
    console.error("Decryption error:", error);
    return null;
  }
};

// interface MyJwtPayload {
//   sub: string;
//   name: string;
//   role: string;
//   exp: number;
//   iat: number;
// }

// export function validateJWT(token: string | null) {
//   if (!token) {
//     return { valid: false, expired: true, decoded: null };
//   }
//   try {
// const decoded = jwt_decode<MyJwtPayload>(token);
//     const currentTime = Date.now() / 1000;

//     if (decoded.exp && decoded.exp < currentTime) {
//       return { valid: false, expired: true, decoded };
//     }

//     return { valid: true, expired: false, decoded };
//   } catch (error) {
//     return { valid: false, expired: true, decoded: null };
//   }
// }
